module.exports = __webpack_public_path__ + "img/09.e7580309.png";